"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getImagePropertiesValidationState() {
    return (state, actions) => () => {
        const tabNames = Object.keys(state.tabs);
        return tabNames.reduce((validationState, tabName) => {
            validationState[tabName] = {
                imageDimensions: state.tabs[tabName].imageDimensions,
                containerDimensions: state.tabs[tabName].containerDimensions,
                evaluatedImageUrl: state.tabs[tabName].finalImageUrl,
                evaluatedImageAlternativeText: state.tabs[tabName].finalImageAlternativeText,
            };
            return validationState;
        }, {});
    };
}
exports.getImagePropertiesValidationState = getImagePropertiesValidationState;
//# sourceMappingURL=get-image-properties-validation-state.js.map